export default {
      id: "icon-info-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-info",
      toString: function () {
        return this.url;
      }
    }